<template>
  <div class="mt30">
    <div class="common-form" style="border-bottom: 1px solid #DCDFE6;">技师统计</div>
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="时间筛选:">
          <el-date-picker size="small" v-model="searchForm.datePicker" type="daterange" align="right" unlink-panels format="yyyy-MM-dd" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="changeDate" :picker-options="pickerOptions"></el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="Echarts">
      <div ref="chart" style="width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import StatisticsApi from "@/api/statistics.js";
import { formatDate } from "@/utils/DateTime.js";
export default {
  data() {
    let endDate = new Date();
    let startDate = new Date();
    startDate.setTime(startDate.getTime() - 3600 * 1000 * 24 * 7);
    return {
      /*是否正在加载*/
      loading: true,
      /*类别*/
      activeName: "new",
      /*时间快捷选项*/
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      searchForm: {
        datePicker: [
          formatDate(startDate, "yyyy-MM-dd"),
          formatDate(endDate, "yyyy-MM-dd")
        ]
      },

      /*数据对象*/
      dataList: null,
      /*交易统计图表对象*/
      myChart: null,
      /*图表数据*/
      option: {
        title: {
          //text: 'ECharts 入门示例'
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        yAxis: {}
      }
    };
  },
  created() {},
  mounted() {
    this.myEcharts();
  },
  methods: {
    /*选择时间*/
    changeDate() {
      this.getData();
    },

    /*创建图表对象*/
    myEcharts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.chart);
      /*获取列表*/
      this.getData();
    },

    /*格式数据*/
    createOption() {
      if (!this.loading) {
        let names = ["新增技师", "认证技师"];
        let xAxis = this.dataList.days;
        let series1 = [];
        let series2 = [];
        this.dataList.data.forEach(item => {
          series1.push(item.add_num);
          series2.push(item.auth_num);
        });

        // 指定图表的配置项和数据
        this.option.xAxis = {
          type: "category",
          boundaryGap: false,
          data: xAxis
        };
        this.option.color = ["#99adf7", "#7ee4c1"];

        this.option.legend = {
          data: [{ name: names[0], color: "#ccc" }, { name: names[1] }]
        };
        this.option.series = [
          {
            name: names[0],
            type: "line",
            data: series1,
            smooth: true,
            lineStyle: {
              color: "#99adf7"
            }
          },
          {
            name: names[1],
            type: "line",
            data: series2,
            smooth: true,
            lineStyle: {
              color: "#7ee4c1"
            }
          }
        ];

        this.myChart.setOption(this.option);
        this.myChart.resize();
      }
    },

    /*获取列表*/
    getData() {
      let self = this;
      self.loading = true;
      StatisticsApi.getWaitertable(
        {
          search_time: self.searchForm.datePicker
        },
        true
      )
        .then(res => {
          self.dataList = res.data;
          self.loading = false;
          self.createOption();
        })
        .catch(error => {});
    }
  }
};
</script>

<style>
.Echarts {
  box-sizing: border-box;
}
.Echarts > div {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics/user/part/Transaction.vue